import LoginShell from '../../../layouts/LoginShell.vue';
import ApprenticeShell from '../../../layouts/ApprenticeShell.vue';
import Login from '../views/Login.vue';
import Registration from '../views/Registration.vue';
import Dashboard from '../views/ApprenticeDashboard.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import CreateInterestsTemplate from '../views/interestsection/CreateInterestsTemplate.vue';
import ProgramCriteria from '../views/CreateInterests.vue';
import UserInterestsLanding from '../views/UserInterestsLanding.vue';
import ManageInterestCriteria from '../views/ManageInterestCriteria.vue';
import workflow from './userinterestworkflow';

import InterestedCompaniesDashboard from '../views/smartrecruit/InterestedCompaniesDashboard.vue';
import InterestedCompaniesStatusboard from '../views/smartrecruit/InterestedCompaniesStatusboard.vue';
import MyApplications from '../views/smartrecruit/MyApplications.vue';
import MyApplicationsDashboard from '../views/smartrecruit/MyApplicationsDashboard.vue';

import RoleMatchingApprenticePage from '../views/apprentice-role-matching.vue';
import ConfirmApplyForApprenticeRoleDialog from '../views/ConfirmApplyForApprenticeRoleDialog.vue';
import ApprenticeRolePostingPage from '../views/apprentice-role-posting.vue';
import SuperAdminLoginApprentice from '../views/SuperAdminLoginApprentice.vue';

import ApprenticeProfilePageSetting from '../views/profilepage/ApprenticeProfilePageSetting.vue';

export default [{
    path: '/',
    name: 'apprenticeLoginModule',
    component: LoginShell,
    children: [
      {
        path: 'apprentice-login/',
        name: 'apprentice-login',
        component: Login,
        title: 'Login'
      },
      {
        path: 'apprentice-register',
        name: 'apprentice-register',
        component: Registration,
        title: 'Registration'
      },
      {
        path: '/apprentice-forgot-password/',
        name: 'apprentice-forgot-password',
        component: ForgotPassword,
        title: 'Forgot Password'
      },
      {
        path: '/apprentice-reset-password/:token/:email',
        name: 'apprentice-reset-password',
        component: ResetPassword,
        title: 'Reset Password'
      },
      {
        path: '/login-apprentice/:userId/:apprenticeId/:token',
        name: 'login',
        component: SuperAdminLoginApprentice,
        title: 'Login'
      }
    ]
  },
  {
    path: '/',
    name: 'apprenticeModule',
    component: ApprenticeShell,
    children: [
      {
        path: 'apprentice-dashboard',
        name: 'apprentice-dashboard',
        component: Dashboard,
        title: 'Dashboard',
        meta: {
          requiredRole: 'Apprentice',
        },
      },
      {
        path: 'role-matching-apprentice',
        name: 'role-matching-apprentice',
        component: RoleMatchingApprenticePage,
        title: 'Role Matching',
      },  
      {
        path: 'role-posting-apprentice/:vacantid/:matchdetail',
        name: 'role-posting-apprentice',
        component: ApprenticeRolePostingPage,
        title: 'Role Posting',
      },    
      {
        path: '/interests/apprenticeship',
        name: 'InterestsModule',
        component: CreateInterestsTemplate,
        title: 'Manage Interests',
        meta: {
          //requiredRole: process.env.VUE_APP_ROLE_SUPER_ADMIN
        },
        children: [
          {
            path: '/interests/programcriteria',
            name: 'ProgramCriteria',
            component: ProgramCriteria,
            title: 'Create Interests',
            children: workflow
            }
        ]
      },
      {
        path: '/apply-for-apprentice-role-dialog',
        name: 'ConfirmApplyForApprenticeRoleDialog',
        component: ConfirmApplyForApprenticeRoleDialog,
        title: 'Confirm Apply for Role',
      },
      {
        path: '/interests/criterialanding',
        name: 'UserInterestsLanding',
        component: UserInterestsLanding,
        title: 'Manage Interests',
        meta: {
          //requiredRole: process.env.VUE_APP_ROLE_SUPER_ADMIN
        }
      },
      {
        path: '/interests/manageinterestcriteria',
        name: 'ManageInterestCriteria',
        component: ManageInterestCriteria,
        title: 'SuperAdmin - Manage Criteria',
        meta: {
          //requiredRole: process.env.VUE_APP_ROLE_SUPER_ADMIN
        }
      },
      {
        path: '/apprentice-smart-recruit/interested-companies-dashboard',
        name: 'InterestedCompaniesDashboard',
        component: InterestedCompaniesDashboard,
        title: 'Interested Companies Dashboard',
      },
      {
        path: '/apprentice-smart-recruit/interested-companies-dashboard/statusboard/:status',
        name: 'InterestedCompaniesStatusboard',
        component: InterestedCompaniesStatusboard,
        title: 'Interested Status Board',
      },
      {
        path: '/apprentice-smart-recruit/my-applications-dashboard',
        name: 'MyApplicationsDashboard',
        component: MyApplicationsDashboard,
        title: 'My Applications Dashboard',
      },
      {
        path: '/apprentice-smart-recruit/my-applications-dashboard/my-applications',
        name: 'MyApplications',
        component: MyApplications,
        title: 'My Applications',
      },
      {
        path: '/profile/apprentice-page-setting',
        name: 'ApprenticeProfilePageSetting',
        component: ApprenticeProfilePageSetting,
        title: 'Profile Page Settings',
        meta: {
          requiredRole: process.env.VUE_APP_ROLE_APPRENTICE
        }
      },
    ]
  }
];